// Footer Date
document.getElementById("year").innerHTML = new Date().getFullYear();

// Add margin-top to page equal to height of header, on page load
window.addEventListener("load", onLoadFunction);

function onLoadFunction(e) {
  onResizeFunction();
  window.addEventListener("resize", onResizeFunction);
}

function onResizeFunction(e) {
  var h = document.getElementById("header").scrollHeight;
  document.getElementById("introduction").style.paddingTop = h + "px";
}
